module.exports = __webpack_public_path__ + "static/media/ymzc_logo.dd568a69.png";